import React, { useState } from 'react';
import './GalleryPage.css';
import logo from "../assets/bg-remover-logo.png"
import image1 from "../assets/f30b7094-ccc2-4199-bf6b-a4cc867e0f5c-1_all_19821.jpg"
import image2 from "../assets/IMG-20250822-WA0055.jpg"
import image3 from "../assets/IMG-20250822-WA0061.jpg"
import image4 from "../assets/WhatsApp Image 2025-11-08 at 2.09.16 PM.jpeg"
import image5 from "../assets/IMG-20250820-WA0157.jpg"
import image6 from "../assets/IMG-20250820-WA0121.jpg"
import image7 from "../assets/WhatsApp Image 2025-11-08 at 2.12.55 PM.jpeg"
import image8 from "../assets/IMG-20250822-WA0057.jpg"
function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images data
  const galleryImages = [
    {
      id: 1,
      src: image1,
      alt: 'Track and Field Athletes',
      title: 'Track and Field Competition'
    },
    {
      id: 2,
      src: image2,
      alt: 'Kayaking Adventure',
      title: 'Water Sports Adventure'
    },
    {
      id: 3,
      src: image3,
      alt: 'Motorcycle Racing',
      title: 'Motorcycle Racing Championship'
    },
    {
      id: 4,
      src: image4,
      alt: 'Basketball Action',
      title: 'Basketball Tournament'
    },
    {
      id: 5,
      src: image5,
      alt: 'Cycling Team',
      title: 'Cycling Team Competition'
    },
    {
      id: 6,
      src: image6,
      alt: 'Boxing Match',
      title: 'Professional Boxing Match'
    },
    {
      id: 7,
      src: image7,
      alt: 'Football Training',
      title: 'Football Training Session'
    },
    {
      id: 8,
      src: image8,
      alt: 'Swimming Competition',
      title: 'Swimming Championship'
    },
    // {
    //   id: 9,
    //   src: image9,
    //   alt: 'Tennis Match',
    //   title: 'Tennis Championship'
    // },
    // {
    //   id: 10,
    //   src: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&h=600&fit=crop&crop=center',
    //   alt: 'Volleyball Game',
    //   title: 'Volleyball Tournament'
    // }
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-page">
      {/* Main Content - Gallery */}
      <main className="gallery-main">
        <div className="container">
          {/* Hero Image Section */}
          <section className="gallery-hero">
            <div className="hero-image">
              <img
                src={image5}
                alt="Sports Gallery Hero"
                className="hero-img"
              />
              <div className="hero-overlay">
                <h1 className="gallery-title">Sports Gallery</h1>
                <p className="gallery-subtitle">Capturing the spirit of athletic excellence</p>
              </div>
            </div>
          </section>

          {/* Gallery Grid Section */}
          <section className="gallery-section">
            <h2 className="section-title">
              Our <span className="accent-text">Sports</span> Moments
            </h2>
            <div className="title-underline"></div>

            <div className="gallery-grid">
              {galleryImages.map((image) => (
                <div
                  key={image.id}
                  className="gallery-item"
                  onClick={() => handleImageClick(image)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="gallery-image"
                  />
                  <div className="image-overlay">
                    <div className="image-title">{image.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>×</button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="modal-image"
            />
            <div className="modal-title">{selectedImage.title}</div>
          </div>
        </div>
      )}

      {/* Footer - Same as main page */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="ASK ME SPORTS ALLIANCE Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default GalleryPage;
